"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var loadPostcode = function () {
  return function (a) {
    var b = !!document.getElementById("daum_postcode_script");
    return b ? Promise.resolve(window.daum.Postcode) : new Promise(function (b, c) {
      var d = document.createElement("script");
      d.src = a, d.onload = function () {
        try {
          b(window.daum.Postcode);
        } catch (a) {
          c(a);
        }
      }, d.onerror = function (a) {
        return c(a);
      }, d.id = "daum_postcode_script", document.body.appendChild(d);
    });
  };
}(),
    _default = loadPostcode;

exports.default = _default;